import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { AuthStore } from '@store';
import { DateTimeService } from '@services';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-home-installer',
  templateUrl: './home-installer.component.html',
  styleUrls: ['./home-installer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeInstallerComponent implements OnInit {
  registerUrl: string;
  isMobileDevice = false;
  locale = this.dateTimeService.getLocale();

  constructor(
    public authStore: AuthStore,
    private deviceService: DeviceDetectorService,
    private dateTimeService: DateTimeService
  ) {}

  ngOnInit(): void {
    this.isMobileDevice = this.deviceService.isMobile();
    this.registerUrl = environment.registerUrl + environment.authConfig.logoutRedirectUri;
  }
}
